import React from 'react'

import CommonNavbar from '@/components/layouts/common/Navbar'

const Navbar: React.FC = () => {
  return <CommonNavbar breadcrumbs={[{ name: 'Changelog' }]} />
}

export default Navbar
